import React from 'react';

export const RequestMarketImage = () => {
    return (
        <svg
            width="372"
            height="140"
            viewBox="0 0 372 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M175.242 30.1182H208.718C211.084 30.1182 213.307 30.6671 214.9 31.5908H214.901L234.602 43.0039C236.18 43.9197 238.166 44.4903 240.265 44.6797H240.267L265.781 46.9502V46.9492C267.654 47.1168 269.275 47.6123 270.498 48.2939L270.611 48.3594C272.082 49.2119 272.803 50.2407 272.893 51.1924L272.901 51.3818L273 69.1035V69.1045C273.005 70.0047 272.429 71.0421 271.044 71.9355L270.757 72.1113L255.406 81.0625H255.405C253.473 82.1913 252.158 83.8649 252.17 85.8135L252.237 98.3369V98.3379C252.243 99.2991 251.586 100.419 249.995 101.345L249.994 101.346L244.934 104.296C243.286 105.256 241.06 105.766 238.774 105.766C236.632 105.766 234.534 105.318 232.91 104.47L232.592 104.295L223.102 98.7969L223.101 98.7959C221.064 97.6174 218.462 97.0567 215.917 97.0566C213.372 97.0566 210.775 97.6176 208.75 98.7979L190.143 109.646L190.142 109.647C188.564 110.569 186.35 111.118 183.984 111.118H148.152C145.691 111.118 143.509 110.537 141.973 109.649C140.511 108.805 139.787 107.78 139.697 106.822L139.688 106.632L139.576 87.0518C139.564 85.1056 138.231 83.4359 136.287 82.3135L100.288 61.4541L100.287 61.4531C98.6206 60.4888 98.0052 59.3612 98 58.4355C97.9949 57.5122 98.5945 56.3871 100.245 55.4229L100.246 55.4238L112.423 48.3223L112.424 48.3213C114.002 47.3994 116.219 46.8507 118.581 46.8506H138.724C141.363 46.8506 143.942 46.2436 145.889 45.1064L145.89 45.1074L169.084 31.5898L169.085 31.5889C170.663 30.6669 172.876 30.1182 175.242 30.1182Z"
                fill="#DEE6FD"
                stroke="#BED2FF"
                strokeWidth="2"
            />
            <path
                d="M159.277 53.9573L151.731 58.3118L144.133 53.9573L151.679 49.6084L159.277 53.9573Z"
                fill="white"
            />
            <path
                d="M159.277 53.957L159.242 65.6035L151.696 69.9581L151.731 58.3116L159.277 53.957Z"
                fill="#BED2FF"
            />
            <path
                d="M151.73 58.3116L151.695 69.9581L144.104 65.6035L144.132 53.957L151.73 58.3116Z"
                fill="#DEE6FD"
            />
            <path
                d="M178.846 43.754L163.19 52.7889L155.598 48.4343L171.254 39.3994L178.846 43.754Z"
                fill="white"
            />
            <path
                d="M178.846 43.7539L178.777 67.0469L163.121 76.0818L163.19 52.7888L178.846 43.7539Z"
                fill="#BED2FF"
            />
            <path
                d="M163.19 52.7892L163.12 76.0822L155.529 71.7276L155.598 48.4346L163.19 52.7892Z"
                fill="#DEE6FD"
            />
            <path
                d="M202.45 19.1263L194.904 23.4809L180.802 15.3946L188.348 11.04L202.45 19.1263Z"
                fill="white"
            />
            <path
                d="M202.451 19.126L202.319 65.7063L194.773 70.0609L194.905 23.4806L202.451 19.126Z"
                fill="#BED2FF"
            />
            <path
                d="M194.905 23.4808L194.772 70.0611L180.665 61.9805L180.803 15.3945L194.905 23.4808Z"
                fill="#DEE6FD"
            />
            <path
                d="M215.359 27.8664L207.818 32.221L200.221 27.8664L207.767 23.5176L215.359 27.8664Z"
                fill="white"
            />
            <path
                d="M215.358 27.8662L215.225 74.4522L207.685 78.8068L207.817 32.2208L215.358 27.8662Z"
                fill="#BED2FF"
            />
            <path
                d="M207.818 32.2208L207.685 78.8068L200.088 74.4522L200.22 27.8662L207.818 32.2208Z"
                fill="#DEE6FD"
            />
            <path
                d="M227.897 46.0168L220.351 50.3714L212.759 46.0168L220.299 41.668L227.897 46.0168Z"
                fill="white"
            />
            <path
                d="M227.896 46.0166L227.793 80.9561L220.253 85.3107L220.35 50.3712L227.896 46.0166Z"
                fill="#BED2FF"
            />
            <path
                d="M220.351 50.3712L220.253 85.3107L212.655 80.9561L212.759 46.0166L220.351 50.3712Z"
                fill="#DEE6FD"
            />
            <path
                d="M190.193 38.0754L182.647 42.43L175.055 38.0754L182.596 33.7266L190.193 38.0754Z"
                fill="white"
            />
            <path
                d="M190.193 38.0752L190.089 73.0147L182.549 77.3693L182.647 42.4298L190.193 38.0752Z"
                fill="#BED2FF"
            />
            <path
                d="M182.647 42.4298L182.55 77.3693L174.952 73.0147L175.056 38.0752L182.647 42.4298Z"
                fill="#DEE6FD"
            />
            <path
                d="M203.863 57.3606L196.317 61.7152L188.725 57.3606L196.271 53.0117L203.863 57.3606Z"
                fill="white"
            />
            <path
                d="M203.864 57.3604L203.795 80.6534L196.255 85.0079L196.318 61.7149L203.864 57.3604Z"
                fill="#BED2FF"
            />
            <path
                d="M196.317 61.7149L196.254 85.0079L188.662 80.6534L188.725 57.3604L196.317 61.7149Z"
                fill="#DEE6FD"
            />
            <path
                d="M215.546 76.4524L208 80.807L200.402 76.4524L207.948 72.1035L215.546 76.4524Z"
                fill="white"
            />
            <path
                d="M215.546 76.4521L215.511 88.0987L207.966 92.4532L208 80.8067L215.546 76.4521Z"
                fill="#BED2FF"
            />
            <path
                d="M207.999 80.8067L207.965 92.4532L200.373 88.0987L200.401 76.4521L207.999 80.8067Z"
                fill="#DEE6FD"
            />
            <path
                d="M188.597 10.6064L202.698 18.6924L202.95 18.8369L202.949 19.1279L202.932 25.7256L207.517 23.084L207.766 22.9414L208.016 23.084L215.605 27.4336L215.857 27.5781L215.856 27.8691L215.811 43.6777L220.049 41.2354L220.298 41.0918L220.547 41.2344L228.145 45.583L228.397 45.7275L228.396 46.0186L228.293 80.957L228.292 81.2451L228.043 81.3887L220.503 85.7441L220.254 85.8887L220.004 85.7451L216.024 83.4639L216.012 88.1016L216.011 88.3887L215.762 88.5332L208.216 92.8877L207.967 93.0312L207.717 92.8877L200.124 88.5332L199.872 88.3896L199.873 88.0986L199.883 83.4883L196.505 85.4404L196.256 85.585L196.006 85.4414L188.413 81.0869L188.161 80.9424L188.162 80.6523L188.178 74.6953L182.8 77.8027L182.551 77.9463L182.301 77.8037L174.703 73.4502L174.451 73.3057L174.452 73.0146L174.46 70.1143L163.371 76.5146L163.122 76.6592L162.872 76.5156L155.279 72.1611L155.027 72.0166L155.028 71.7256L155.037 68.6074L151.946 70.3916L151.697 70.5361L151.447 70.3926L143.854 66.0381L143.603 65.8936L143.604 65.6035L143.633 53.957L143.634 53.6689L143.883 53.5244L151.429 49.1758L151.678 49.0322L151.927 49.1748L155.09 50.9854L155.099 48.4326L155.1 48.1445L155.349 48.001L171.004 38.9668L171.253 38.8223L171.503 38.9658L174.547 40.7109L174.556 38.0742L174.557 37.7871L174.806 37.6426L180.244 34.5049L180.302 15.3926L180.303 15.1055L180.552 14.9609L188.098 10.6074L188.347 10.4629L188.597 10.6064Z"
                stroke="#333333"
            />
            <path
                d="M255.476 30.6182C262.063 30.6182 267.451 36.0659 267.451 42.7529C267.451 44.9296 266.706 47.2822 265.554 49.6094C264.404 51.9318 262.866 54.1963 261.318 56.1885C259.772 58.1791 258.226 59.8888 257.064 61.1006C256.484 61.7062 256.001 62.187 255.663 62.5156C255.595 62.5816 255.532 62.6399 255.477 62.6934C255.421 62.6391 255.358 62.5786 255.29 62.5117C254.952 62.1799 254.469 61.6953 253.889 61.085C252.727 59.8634 251.18 58.1421 249.634 56.1436C248.086 54.1433 246.547 51.8738 245.397 49.5566C244.245 47.2344 243.5 44.8978 243.5 42.7529C243.5 36.0659 248.888 30.6182 255.476 30.6182Z"
                fill="white"
                stroke="#333333"
            />
            <ellipse
                cx="255.579"
                cy="42.6966"
                rx="6.86099"
                ry="6.86113"
                transform="rotate(-90 255.579 42.6966)"
                fill="#DEE6FD"
            />
            <path
                d="M255.579 35.8356C254.222 35.8356 252.896 36.238 251.767 36.9919C250.639 37.7458 249.76 38.8174 249.24 40.071C248.721 41.3247 248.585 42.7042 248.85 44.0351C249.115 45.366 249.768 46.5886 250.728 47.5481C251.687 48.5076 252.91 49.1611 254.241 49.4258C255.572 49.6905 256.951 49.5546 258.205 49.0354C259.459 48.5161 260.53 47.6367 261.284 46.5084C262.038 45.3801 262.44 44.0536 262.44 42.6966L255.579 42.6966L255.579 35.8356Z"
                fill="#FFBE5E"
            />
        </svg>
    );
};
